import { render, staticRenderFns } from "./pond-page.vue?vue&type=template&id=9321f63c&"
import script from "./pond-page.vue?vue&type=script&lang=js&"
export * from "./pond-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports